import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { IStepConfig, StepType } from "./Process";
import * as classNames from "classNames";
import { ISubSteppersConfig } from "./ProcessStepper";

export interface IProcessSubStepperProps extends React.Props<ProcessSubStepper> {
    currentStep: number;
    endIndex: number;
    config: ISubSteppersConfig;
    onStepLeave: (from: number, to: number) => void;
    canSwitchStep: boolean;
}

export interface IProcessSubStepperState {
    // isExpand: boolean;
}

export class ProcessSubStepper extends BaseComponent<IProcessSubStepperProps, IProcessSubStepperState> {
    constructor(props: any) {
        super(props);
        this.state = {
            // isExpand: false
        };
    }

    private onClickStep(from: number, to: number) {
        if (!this.props.canSwitchStep) {return;}
        this.props.onStepLeave(from, to);
    }

    public render(): JSX.Element {
        const { endIndex, config, currentStep } = this.props;
        const startIndex = endIndex - config.subSteppers.length;
        const isNotYet = currentStep < startIndex;
        const isCurrent = currentStep >= startIndex && currentStep < endIndex;
        const isDone = currentStep >= startIndex + config.subSteppers.length;
        const classes = classNames({ current: isCurrent }, { done: isDone });
        if (isNotYet || isDone)
            {return (
                <li key={startIndex} className={classes}>
                    <span className="ws-1-link">{config.title}</span>
                </li>
            );}
        return (
            <>
                <li key={startIndex} className={"currentWithSubSteps mb-0"}>
                    <div className="ws-1-link">
                        {config.title}{" "}
                        <span className="subStep-counter">{`${currentStep - startIndex + 1}/${
                            config.subSteppers.length
                        }`}</span>
                    </div>
                    <ul className="ws-substeps">
                        {config.subSteppers.map((subConfig, i) => {
                            const classes = classNames({ current: currentStep == i + startIndex });
                            return (
                                <li key={`sub-${i}`} className={classes}>
                                    <div
                                        className="ws-2-link"
                                        onClick={() => this.onClickStep(this.props.currentStep, i + startIndex)}
                                    >
                                        {subConfig.title}
                                        <span className="icon-tick"></span>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </li>
            </>
        );
    }
}
